import { render } from "./IconEdit.vue?vue&type=template&id=dc959c30"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__